
(() => {
  const getMediaId = (value) =>
    String(value || '').split('-').pop();

  function initGallery(gallery) {
    if (gallery.dataset.asVariantGalleryReady === 'true') return;

    const section = gallery.closest('product-info');
    const sectionId = section?.dataset.section;
    const configEl = sectionId
      ? document.getElementById(`AsVariantMediaGallery-${sectionId}`)
      : document.querySelector('script[id^="AsVariantMediaGallery-"]');

    const viewer = gallery.querySelector(
      'slider-component[id^="GalleryViewer"]'
    );

    if (!configEl || !viewer ||
        typeof gallery.setActiveMedia !== 'function') return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('AS gallery config error', error);
      return;
    }

    const mediaIds = (config.mediaIds || []).map(String);

    const starts = [...new Set(
      (config.variantStartMediaIds || []).map(String)
    )]
      .map((id) => mediaIds.indexOf(id))
      .filter((index) => index >= 0)
      .sort((a, b) => a - b);

    if (!starts.includes(0)) starts.unshift(0);

    const slides = Array.from(
      viewer.querySelectorAll('[data-media-id]')
    );

    const thumbnails = Array.from(
      gallery.querySelectorAll(
        '[id^="Slider-Thumbnails"] [data-target]'
      )
    );

    if (!slides.length || !mediaIds.length) return;

    const getIndex = (value) =>
      mediaIds.indexOf(getMediaId(value));

    function getRange(index) {
      let start = 0;
      let end = mediaIds.length;

      starts.forEach((position, i) => {
        if (position <= index) {
          start = position;
          end = starts[i + 1] ?? mediaIds.length;
        }
      });

      return { start, end };
    }

    function selectedIndex() {
      const thumb = gallery.querySelector(
        '[id^="Slider-Thumbnails"] .thumbnail[aria-current="true"]'
      )?.closest('[data-target]');

      const thumbIndex = getIndex(thumb?.dataset.target);
      if (thumbIndex >= 0) return thumbIndex;

      const active = slides.find(
        (slide) => slide.classList.contains('is-active')
      );

      return Math.max(0, getIndex(active?.dataset.mediaId));
    }

    let currentIndex = selectedIndex();
    let range = getRange(currentIndex);

    function filterGallery(index) {
      range = getRange(index);

      slides.forEach((slide) => {
        const mediaIndex = getIndex(slide.dataset.mediaId);
        const visible =
          mediaIndex >= range.start && mediaIndex < range.end;

        slide.hidden = !visible;
        slide.style.display = visible ? '' : 'none';
        slide.setAttribute('aria-hidden', String(!visible));
      });

      thumbnails.forEach((thumb) => {
        const mediaIndex = getIndex(thumb.dataset.target);
        const visible =
          mediaIndex >= range.start && mediaIndex < range.end;

        thumb.hidden = !visible;
        thumb.style.display = visible ? '' : 'none';
      });

      viewer.resetPages?.();
      viewer.initPages?.();
    }

    function activateIndex(index) {
      if (index < range.start || index >= range.end) return;

      currentIndex = index;

      gallery.setActiveMedia(
        `${config.sectionId}-${mediaIds[index]}`,
        false
      );

      setTimeout(() => {
        viewer.resetPages?.();

        const activeSlide = slides.find(
          (slide) => getIndex(slide.dataset.mediaId) === index
        );

        if (
          activeSlide &&
          window.matchMedia('(max-width: 749px)').matches
        ) {
          viewer.slider?.scrollTo({
            left: activeSlide.offsetLeft,
            behavior: 'instant'
          });
        }
      }, 100);
    }

    function selectVariant(index) {
      if (index < 0 || index >= mediaIds.length) return;

      currentIndex = index;
      filterGallery(index);
      activateIndex(index);
    }

    gallery.addEventListener('click', (event) => {
      const button = event.target.closest(
        'slider-component[id^="GalleryViewer"] .slider-button'
      );

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const next = button.classList.contains('slider-button--next')
        ? (currentIndex + 1 >= range.end
            ? range.start : currentIndex + 1)
        : (currentIndex - 1 < range.start
            ? range.end - 1 : currentIndex - 1);

      activateIndex(next);
    }, true);

    viewer.addEventListener('slideChanged', (event) => {
      const index = getIndex(
        event.detail?.currentElement?.dataset.mediaId
      );

      if (index >= range.start && index < range.end) {
        currentIndex = index;
      }
    });

    document.addEventListener('variant:change', (event) => {
      const id = event.detail?.variant?.featured_media?.id;
      if (!id) return;

      const index = mediaIds.indexOf(String(id));
      if (index >= 0) selectVariant(index);
    });

    document.addEventListener('change', (event) => {
      if (section && !section.contains(event.target)) return;

      setTimeout(() => {
        const index = selectedIndex();

        if (
          index >= 0 &&
          (index < range.start || index >= range.end)
        ) {
          selectVariant(index);
        }
      }, 220);
    });

    gallery.dataset.asVariantGalleryReady = 'true';
    filterGallery(currentIndex);
  }

  function init() {
    document.querySelectorAll('media-gallery')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
